import { useContext } from "react";
import { TenantContext, type ITenantContext } from "./TenantContext";

export function useTenant(): ITenantContext {
  const context = useContext(TenantContext);

  if (!context) {
    throw new Error("useTenant must be used inside TenantProvider.");
  }

  return context;
}
